module.exports = __webpack_public_path__ + "img/jellybean_equinox.cce31f26.png";